<template>
  <section class="create__scope">
    <div class="nr_container_content">
      <h1 class="mb-5 mt-30">Добавление вида упаковки</h1>
      <v-form class="form"
              v-model="valid"
      >
        <div class="inner">
          <div class="box">
            <div class="d-flex flex-column mb-3">
              <v-checkbox
                  v-model="activity"
                  label="Активность"
                  hide-details
                  @change="change_activity()"

              >
              </v-checkbox>
            </div>
          </div>
<!--          <div class="box">-->
<!--            <span class="label">Категория <span class="color-red">*</span></span>-->
<!--            <v-select class="input"-->
<!--                      v-model="catSelect"-->
<!--                      :items="category"-->
<!--                      item-value="id"-->
<!--                      item-text="name"-->

<!--                      :rules="[rules.required]"-->
<!--                      outlined-->
<!--                      rounded-->
<!--                      required-->
<!--                      maxlength="100"-->
<!--            >-->
<!--              <template v-slot:item="{ item }">-->
<!--                <div class="select__item">-->
<!--                  <div class="cb">-->
<!--                    <span class="circle"></span>-->
<!--                  </div>-->
<!--                  <span class="value">{{ item.name }}</span>-->
<!--                </div>-->
<!--              </template>-->
<!--            </v-select>-->
<!--          </div>-->
          <div class="box">
            <span class="label">Таб <span class="color-red">*</span></span>
            <v-text-field class="input"
                          v-model="title"
                          outlined
                          :rules="[rules.required]"
                          placeholder="прим.Бытовые холодильники"
            />
          </div>
          <div class="box">
            <div v-for="(point, idx) of points"
                 :key="idx" class="">
              <div v-if="point.visibleModal" class=" box_area">
                <div class="box_area__modal">
                
                  <div class="d-flex flex-column">
                    <span class="label">Название точки </span>
                    <v-text-field class="input nameOfCategory"
                                  v-model="point.nameOfCategory"
                                  outlined
                    />
                  </div>
<!--                  <div class="d-flex flex-column">

                    <span class="label">Картинка точки</span>
                    <div class="photo">
                      <input class="file_input"
                             type="file"
                             accept="image/*"
                             @change="select_file_dot(`photo_${idx + 1}`, point)"
                             :ref="`photo_${idx + 1}`"
                      >
                      <img class="preview"
                           v-if="point.photo.length !== 0"
                           :src="point.photo_preview.src"
                      >
                      <button class="delete"
                              v-if="point.photo.length !== 0"
                              @click.prevent="remove_file(`photo_${idx + 1}`, point)"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 15 15" fill="none">
                          <path d="M1 1L14 13.9978" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
                          <path d="M1 14L14 1.00224" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                      </button>
                      <svg class="icon" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"
                           fill="none">
                        <g clip-path="url(#clip0_728_42948)">
                          <path
                              d="M31.6667 15H25V5H15V15H8.33337L20 26.6667L31.6667 15ZM8.33337 30V33.3333H31.6667V30H8.33337Z"
                              fill="#8B8B8B"/>
                        </g>
                        <defs>
                          <clipPath id="clip0_728_42948">
                            <rect width="40" height="40" fill="white"/>
                          </clipPath>
                        </defs>
                      </svg>
                    </div>


                  </div>-->

                  <div class="d-flex flex-column">
                    <span class="label">Текст</span>
                    <vue-editor v-model="point.editorContent" class="w-100"/>
                  </div>
                  <div class="d-flex flex-column">
                    <span class="label">Координаты точки(для справки - не редактируются)</span>
                    <div>Top: <input type="text" placeholder="top" disabled v-model="point.pointPositionTop"></div>
                    <div>Left: <input type="text" placeholder="left" disabled v-model="point.pointPositionLeft"></div>
                  </div>
                  <div>
                    <button class="send_custom mt-4" @click="point.draggable=false;activePointInd='';point.visibleModal=false">
                      Применить к точке
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="box">
            <span class="label">Картинка</span>
            <div class="d-flex flex-wrap">
              <div class="banner mr-4 mb-5">
                <div v-if="banner_preview.src"
                     :class="[typeof(activePointInd) == 'number' ? 'cursor-none pointFix': '']"
                     class="drag_area w-100 h-100 position-absolute"
                     @click="typeof activePointInd  == 'number' ? pointFix(): ''"
                     @mousemove="moveCursorArea($event)">
                  <div class="drag_area__item" title="Двойной клик - режим правки текста. Одинарный - перемещение точки"
                       :class="[point.draggable ? 'active': '']"
                       :style="{top: Math.abs(point.pointPositionTop)+'%', left: Math.abs(point.pointPositionLeft)+'%'}"
                       v-for="(point, idx) of points"
                       @click="pointMoving(point, idx)"
                       @dblclick="pointEditContent(idx)"
                       :key="idx"

                  ></div>
                </div>
                <input class="file_input"
                       type="file"
                       accept="image/*"
                       @change="select_file('banner')"
                       ref="banner"
                >
                <img class="preview"
                     v-if="banner_preview.src"
                     :src="banner_preview.src"
                     :alt="banner_preview.name"
                >
                <!--              <button class="delete"-->
                <!--                      v-if="banner_preview.src"-->
                <!--                      @click.prevent="remove_file('banner')"-->
                <!--              >-->
                <!--                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">-->
                <!--                  <path d="M1 1L14 13.9978" stroke="#fff" stroke-width="2" stroke-linecap="round"/>-->
                <!--                  <path d="M1 14L14 1.00224" stroke="#fff" stroke-width="2" stroke-linecap="round"/>-->
                <!--                </svg>-->
                <!--              </button>-->
                <svg class="icon" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"
                     fill="none">
                  <g clip-path="url(#clip0_728_42948)">
                    <path
                        d="M31.6667 15H25V5H15V15H8.33337L20 26.6667L31.6667 15ZM8.33337 30V33.3333H31.6667V30H8.33337Z"
                        fill="#8B8B8B"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_728_42948">
                      <rect width="40" height="40" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div class="btn_menu ">
                <button class="btn_def add_point p-4 mb-4" @click.prevent="addPoint">
                  Добавить точку
                </button>
<!--                <button class="btn_def remove_point p-4 mb-4" @click.prevent="pointEditContent_btn">
                  Изменить активную точку
                </button>-->
                <button class="btn_def remove_point p-4 mb-4" @click.prevent="remove_point">
                  Удалить активную точку
                </button>
                <button class="btn_def replace_img p-4" @click.prevent="replace_img">
                  Заменить картинку <br>(точки не сбросятся)
                </button>
              </div>
            </div>

          </div>
        </div>

        <div class="buttons mb-5">

          <button class="send_custom"
                  @click.prevent="send_data"
                  :disabled="!valid"
                  ref="send_btn"
          >
            Сохранить
          </button>
        </div>
      </v-form>
      <div class="create__scope__modal"
           v-if="modal"
      >
        <div class="modal__inner"
             ref="modal"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
            <path
                d="M45.8333 23.0848V25.0015C45.8307 29.4941 44.376 33.8654 41.6861 37.4636C38.9961 41.0619 35.2151 43.6942 30.907 44.968C26.5988 46.2418 21.9942 46.0888 17.7801 44.5319C13.566 42.975 9.96799 40.0975 7.52279 36.3287C5.0776 32.5599 3.91619 28.1016 4.21179 23.6188C4.50738 19.136 6.24414 14.8689 9.16304 11.4537C12.0819 8.03863 16.0266 5.65855 20.4087 4.66848C24.7908 3.6784 29.3755 4.13138 33.4791 5.95984"
                stroke="#FA4237" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M45.8333 8.33594L25 29.1901L18.75 22.9401" stroke="#FA4237" stroke-width="3" stroke-linecap="round"
                  stroke-linejoin="round"/>
          </svg>
          <h3 class="modal__title">
            Отправлено
          </h3>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
import rules from "../../../rules";
import {VueEditor} from "vue2-editor";

export default {
  components: {VueEditor},
  name: "addScope",
  props: {
    cat: String | Number | Boolean | Object | Array,
  },
  data() {
    return {
      valid: false,
      title: '',

      banner: [],

      banner_preview: {
        name: '',
        src: ''
      },
      rules: rules,
      modal: false,
      activity: '',
      activePointInd: '',

      points: [
        {
          editorContent: '<p>Каркас по умолчанию</p><p class="areas__points-head"><h3 class="areas__points-title">Заголовок</h3></span> <p class="areas__points-products"><span>Продукт:</span> самоклеящаяся плёнка для временной защиты  поверхности</p> <p class="areas__points-assignment"><span>Назначение:</span> временная защита стеклянных, пластиковых или окрашенных металлических деталей от царапин, пыли и других повреждений во время транспортировки и монтажа</p> <ul class="areas__points-list"><li class="areas__points-item"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.6668 5L7.50016 14.1667L3.3335 10" stroke="#F94337" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg> <span>Удаление без оставления следов</span></li><li class="areas__points-item"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.6668 5L7.50016 14.1667L3.3335 10" stroke="#F94337" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg> <span>Устойчивы к старению</span></li><li class="areas__points-item"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.6668 5L7.50016 14.1667L3.3335 10" stroke="#F94337" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg> <span>Надёжное удержание на поверхности</span></li></ul>',
          pointPositionTop: '3',
          pointPositionLeft: '3',

          visibleModal: false, // двойной клик - true(открывается модалка для правки текста)
          draggable: false, // true - режим изменения точки

          nameOfCategory: "",
          photo: [],
          photo_preview: {
            name: '',
            src: ''
          },
        },
      ],

      // category: this.cat,

      /*category: [
        {
          id: '1',
          name: 'кат1'
        },
        {
          id: '2',
          name: 'кат2',
        },
        {
          id: '3',
          name: 'кат3'
        }
      ],*/
      // catSelect: '',
    }
  },
  methods: {
    select_file_dot(ref, point) {
      console.log(ref)
      for (let file of this.$refs[ref][0].files) {
        point.photo.push(file);
        point.photo_preview = {
          name: file.name,
          src: URL.createObjectURL(file)
        }
      }

    },
    remove_file(ref, point) {
      point.photo = [];
      point.photo_preview = {
        name: '',
        src: ''
      }

    },

    select_file(ref) {
      console.log(ref)
      if (ref === 'banner') {
        for (let file of this.$refs[ref].files) {
          this.banner.push(file);
          this.banner_preview.name = file.name;
          this.banner_preview.src = URL.createObjectURL(file);
        }
      }
    },
    send_data() {
      let url = "/ajax/add-scope-points.php";
      const form_data = new FormData();

      form_data.append('banner', this.banner[0]);

      form_data.append('ajaxPost', "Y");
      const json_data = {
        title: this.title,
        // scopeId: this.catSelect,
          active: this.activity,
        points: this.points, // массив точек с заполенным редактором
      }
      form_data.append('data', JSON.stringify(json_data));
      console.log(...form_data);

      //const form_data_dots = new FormData();
      this.points.forEach((el) => {
        form_data.append(`points[${el.tmpId}]`, el.photo[0]);
      });
      
      var result = fetch(url, {method: "POST", body: form_data})
          .then(function (response) {
            return response.json();
          })
          .then((data) => {
            console.log(JSON.stringify(data));
          });

      // Поставь jquery
      // $.ajax({
      //   "type": "POST",
      //   "url": "/ajax/workers_add.php",
      //   "dataType": "json",
      //   "cache": false,
      //   "contentType": false,
      //   "processData": false,
      //   "data": form_data,
      //   "success": function (result) {
      //     console.log(result);
      //   },
      //   "error": function (xhr, ajaxOptions, thrownError) {
      //     console.log(xhr.status);
      //     console.log(thrownError);
      //   }
      // });

      this.modal = true;
    },
    closeModal($event) {
      const modal = $event.composedPath().includes(this.$refs.modal);
      const button = $event.composedPath().includes(this.$refs.send_btn);
      if (this.modal) {
        if (!modal && !button) {
          this.modal = false
        }
      }
    },

    moveCursorArea(event) { // отслеживание курсора в пределах облости
      console.log(event);
      if (typeof (this.activePointInd) == "number") {
        this.points[this.activePointInd].pointPositionTop = event.offsetY / 596 * 100;
        this.points[this.activePointInd].pointPositionLeft = event.offsetX / 663 * 100 + 3;
      }
    },
    pointFix() {
      this.points[this.activePointInd].draggable = false;
      this.activePointInd = '';
    },
    pointMoving(point, idx) {
      let vueObj = this;
      setTimeout(function () {
        vueObj.activePointInd = idx;
        point.draggable = !point.draggable;
      }, 10);
    },

    pointEditContent(idx) { // правка точки двойным кликом по ней
      this.points[idx].visibleModal = true;
    },
    pointEditContent_btn() {
      if (typeof (this.activePointInd) == "number") {
        this.points[this.activePointInd].visibleModal = true;
      } else {
        alert("Активируйте точку чтобы изменить")
      }
    },

    remove_point() {
      if (typeof (this.activePointInd) == "number") {
        delete this.points[this.activePointInd];
        this.points.splice(this.activePointInd, 1);
        this.activePointInd = '';
      } else {
        alert("Активируйте точку чтобы удалить")
      }
    },
    addPoint() {
      let arr = {
        editorContent: '<p>Каркас по умолчанию</p><p class="areas__points-head"><h3 class="areas__points-title">Заголовок</h3></span> <p class="areas__points-products"><span>Продукт:</span> самоклеящаяся плёнка для временной защиты  поверхности</p> <p class="areas__points-assignment"><span>Назначение:</span> временная защита стеклянных, пластиковых или окрашенных металлических деталей от царапин, пыли и других повреждений во время транспортировки и монтажа</p> <ul class="areas__points-list"><li class="areas__points-item"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.6668 5L7.50016 14.1667L3.3335 10" stroke="#F94337" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg> <span>Удаление без оставления следов</span></li><li class="areas__points-item"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.6668 5L7.50016 14.1667L3.3335 10" stroke="#F94337" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg> <span>Устойчивы к старению</span></li><li class="areas__points-item"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.6668 5L7.50016 14.1667L3.3335 10" stroke="#F94337" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg> <span>Надёжное удержание на поверхности</span></li></ul>',
        pointPositionTop: '3',
        pointPositionLeft: '3',
        visibleModal: false,
        draggable: false,
        nameOfCategory: "",
        photo: [],
        photo_preview: {
          name: '',
          src: ''
        },
        activity: '',
        tmpId: "tmp_" + Math.floor(Math.random() * 10000),
      };
      this.points.push(arr);
    },
    replace_img(ref) {
      this.banner = [];
      this.banner_preview = {name: '', src: ''};
      this.$refs.banner.value = null;
    },
    change_activity(point, idx) {
      console.log("log");
    }
  },

  mounted() {
    document.addEventListener('click', this.closeModal);
  }

};
</script>

<style lang="scss" scoped>
@import "../../../theme/variable";

.create__scope {
  width: 100%;
  //margin-top: 165px;

  h1 {
    font-size: 33px;
    color: #373535;
  }
  & .btn_menu {
    width: 200px;

    button:hover {
      opacity: .8;
    }
  }

  & .box_area {
    position: fixed;
    background: #00000057;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 999;


    & .box_area__modal {
      width: 58% !important;
      height: auto;
      max-height: 600px;
      overflow-y: auto;
      margin: 0 auto;
      margin-top: 80px;
      padding: 15px;
      background: white;
      box-shadow: 0 0 10px -5px black;
      border-radius: 10px;

      & .label {
        margin-top: 16px;
        margin-bottom: 10px;
        font-size: 15px;
        font-family: 'RobotoMedium';
        color: #171616;
      }
    }
  }

  & .v-text-field__details {
    display: block !important;
    color: red;
  }

  & .form {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 30px;
  }

  & .inner {
    width: 100%;
    border-radius: 16px;
    background: #FFF;
    box-shadow: 3px 3px 25px 0 rgba(0, 0, 0, 0.05);
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 10px;
    position: relative;
  }

  & .delete_worker {
    position: absolute;
    top: 30px;
    right: 30px;
    padding: 10px 20px;
    background: #F44336;
    border-radius: 10px;
    color: #FFFFFF;
    font-weight: 500;
  }

  & .box {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: start;

  }

  & .label {
    color: #7E7F80;
    font-family: 'Roboto', sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%;
    margin-bottom: 10px;
  }

  & .input {
    width: 100%;
  }

  & .banner, & .photo {
    height: 598px;
    width: 665px;
    background-color: #fefefe;
    border-radius: 10px;
    overflow: hidden;
    border: 1px dashed #DFDFE3;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    & .drag_area {
      position: absolute;
      z-index: 3;

      &.cursor-none {
        cursor: none;
      }

      & .drag_area__item {
        position: absolute;
        width: 2.2rem;
        height: 2.2rem;
        border-radius: 100%;
        background-color: #00A6F0;
        cursor: pointer;
        left: 0;
        top: 0;

        &.active {
          cursor: none;
          box-shadow: 0px 0px 0px 5px rgb(0 166 240 / 22%);
          z-index: 4;
        }
      }
    }

    & .file_input {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
      z-index: 2;
    }

    & .preview {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      cursor: pointer;
      z-index: 1;
      object-fit: contain;
      padding: 34px;
    }

    & .delete {
      position: absolute;
      top: 20px;
      right: 20px;
      background: rgba(0, 0, 0, .5);
      width: 30px;
      height: 30px; 
      border-radius: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 3;
    }
  }

  & .photo {
    width: 120px;
    height: 120px;
    overflow: visible;

    & .preview {
      border-radius: 10px;
    }

    & .delete {
      top: 0;
      right: -25px;
      width: 20px;
      height: 20px;
    }
  }

  & .buttons {
    width: 100%;
    background: transparent;
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 20px;
  }

  & .btn_def {
    border-radius: 16px;
    background: #FFF;
    box-shadow: 3px 3px 25px 0 rgba(0, 0, 0, 0.05);
    padding: 18px 0;
    width: 100%;
    text-align: center;

    color: #404040;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    transition: all .3s ease;
  }

  & .send_custom {
    text-transform: uppercase;
    width: 100%;
    border-radius: 16px;
    background: #FA4237;
    padding: 10px 20px;
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: center;

    color: #FFF;
    text-align: center;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.42px;
    transition: all .3s ease;

    &:disabled {
      background-color: #acaeb1;
      cursor: default;

      &:hover {
        background-color: #95999f;
      }
    }
  }

  &__modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.47);
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;

    animation: modal .3s ease;

    @keyframes modal {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }

    & .modal__inner {
      border-radius: 15px;
      background: #FFF;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.06);
      padding: 40px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      max-width: 430px;
      width: 100%;
      @media(min-width: 576px) {
        padding: 24px;
      }

    }

    & .modal__title {
      color: #242424;
      font-size: 20px;
      font-style: normal;
      font-weight: 400;
      line-height: 120%;
      letter-spacing: 0.2px;
    }
  }
}

</style>

<style lang="scss">
@import "../../../theme/variable";

.nameOfCategory {
  & .v-text-field__details {
    display: none !important;
  }

}

.color-red {
  color: red;
}

.create__scope {
  .v-text-field--outlined, .v-text-field--solo {
    border-radius: 8px !important;
  }

  .v-text-field--outlined fieldset {
    border-color: #DFDFE3 !important;
  }

  .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot, .v-text-field.v-text-field--enclosed .v-text-field__details {
    padding: 0 15px !important;
  }

  .v-text-field--outlined.v-input--is-focused fieldset, .v-text-field--outlined.v-input--has-state fieldset {
    border: 1px solid #DFDFE3 !important;
  }

  .v-text-field__details {
    display: flex;
  }

  .theme--light.v-messages {

  }
}
</style>